import PropTypes from 'prop-types';
import React from 'react';
import Article from '../article';

const MatchReport = ({ image, report, team, album, shareUrl }) => {
  if (!report) {
    return <span>coming soon</span>;
  }

  return (
    <>
      <Article
        imageAlt={report.title}
        imageSrc={image}
        title={report.title}
        author={report.author}
        tagline={report.tagline}
        published={report.published}
        team={team}
        album={album && !album.accessDenied ? album : null}
        shareProps={{
          imageUrl: image,
          description: report.tagline,
          title: report.title,
          url: shareUrl,
        }}
      >
        <div className="bbcode-content" dangerouslySetInnerHTML={{ __html: report.html }} />
      </Article>
    </>
  );
};

MatchReport.defaultProps = {
  image: null,
  report: null,
  album: null,
};

MatchReport.propTypes = {
  image: PropTypes.string,
  report: PropTypes.shape({
    id: PropTypes.string,
    author: PropTypes.shape(),
    tagline: PropTypes.string,
    title: PropTypes.string,
    html: PropTypes.string,
    published: PropTypes.string,
  }),
  team: PropTypes.shape({}).isRequired,
  album: PropTypes.shape({
    accessDenied: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape()),
  }),
  shareUrl: PropTypes.string.isRequired,
};

export default MatchReport;
